(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'jquery', 'torso/modules/Collection', './StoredPaymentMethodModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var _ = require('underscore');
    var $ = require('jquery');
    var TorsoCollection = require('backbone-torso/modules/Collection');
    var StoredPaymentMethodModel = require('./StoredPaymentMethodModel');
    var urls = require('./../urls');
    module.exports = factory(_, $, TorsoCollection, StoredPaymentMethodModel, urls);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, $, TorsoCollection, StoredPaymentMethodModel, urls) {
  'use strict';

  /**
   * Collection of stored payment methods
   *
   * @class PaymentMethodCollection
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: StoredPaymentMethodModel,
    url: urls.storedPaymentMethodExtService,
    fetchHttpAction: 'POST',

    /**
     * Fetch the ids of the stored payment methods by patient vecna id.
     * @param patientVecnaId {String} of the patient to get the stored payment method ids for.
     * @return {Deferred} a promise that resolves with the list of vecna ids of the stored payment methods for the given patient.
     *                    if patientVecnaId is falsey then no results are returned.
     */
    fetchIdsForPatient: function(patientVecnaId) {
      // Only search if patient vecna id is set.
      if (!patientVecnaId) {
        return $.Deferred().resolve().promise();
      }
      var criteria = {
        patientVecnaId: patientVecnaId
      };
      return this.fetchIdsByCriteria(criteria);
    },

    /**
     * Fetch the ids of the stored payment methods by patient vecna id.
     * @param criteria {Object} the critera to use to search for patient vecna ids.
     *   @param criteria.patientVecnaId {String} of the patient to get the stored payment method ids for.
     * @return {Deferred} a promise that resolves with the list of vecna ids of the stored payment methods for the given patient.
     *                    if patientVecnaId is falsey then no results are returned.
     */
    fetchIdsByCriteria: function(criteria) {
      // Only search if patient vecna id is set.
      if (!criteria.patientVecnaId) {
        return $.Deferred().resolve().promise();
      }
      return $.ajax({
        url: this.url + '/searchIds',
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(criteria)
      });
    },

    /**
     * A comparator that compares the payment methods based on their defaultPaymentMethod value. The default payment method is sorted to the top.
     * @method comparator
     * @method override
     */
    comparator: function(firstModel, secondModel) {
      var firstModelDefault = firstModel.get('defaultPaymentMethod');
      var secondModelDefault = secondModel.get('defaultPaymentMethod');

      if (firstModelDefault && !secondModelDefault) {
        return -1;
      } else if (secondModelDefault && !firstModelDefault) {
        return 1;
      } else {
        var firstModelNickname = firstModel.get('nickname');
        var secondModelNickname = secondModel.get('nickname');
        if(firstModelNickname === secondModelNickname) {
          return 0;
        } else if(_.isString(firstModelNickname) && _.isString(secondModelNickname)) {
          return firstModelNickname.localeCompare(secondModelNickname);
        } else if(!_.isString(firstModelNickname)) {
          // firstModelNickname is NOT a string : secondModelNickname is a string.
          return 1;
        } else {
          // firstModelNickname is a string : secondModelNickname is NOT a string.
          return -1;
        }
      }
    }
  }))();
}));
